import { fail, pass, skip } from "../../buildResult";
import { defineTest } from "../../defineTest";
import {
  AUDIO_INGEST_LAMBDAS,
  getEndedIngestLambdas,
  resolveTrace,
} from "../../helper/trace";

export default defineTest(
  "trace_audio_ingest_completed",
  "Audio ingest completed",
  ({ trace, fetchErrors }) => {
    const resolved = resolveTrace({ trace, fetchErrors });
    if (!resolved.ok) return resolved.result;

    const { events } = resolved;
    if (events.length === 0) return skip("Trace has no events");

    const endedIngest = getEndedIngestLambdas(events);

    if (endedIngest.length === 0) {
      return fail(
        `No completed audio ingest: expected ${AUDIO_INGEST_LAMBDAS.join(" or ")} with status END`
      );
    }

    return pass(`Audio ingest completed (${endedIngest.join(", ")})`);
  }
);
